import { parseCellCode } from '@eombor/contracts';
import { cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';

/**
 * KATAK KODI — o'zini tushuntiradigan holda.
 *
 * `A-01-02-03` skladchiga o'z-o'zidan hech narsa demaydi: to'rtta bo'lakning
 * qaysi biri qator, qaysi biri o'rin ekanini yodlab olish kerak bo'ladi va
 * ikkinchi bilan uchinchini almashtirib yuborish — mahsulotni bo'sh katakdan
 * qidirish demak.
 *
 * Shuning uchun kod HAR JOYDA shu komponent orqali chiziladi va yonida
 * ma'nosi turadi. Matn ekran o'quvchiga ham beriladi, ya'ni kodni eshitgan
 * odam ham qayerdaligini biladi.
 *
 * Format o'zgarmaydi — u fizik etiketkada bosilgan. O'zgaradigan narsa —
 * uni ODAMGA qanday ko'rsatishimiz.
 */

export interface CellCodeProps {
  code: string;
  /** Ma'nosini kod OSTIDA yozadi. Bo'lmasa faqat sichqoncha ostida ko'rinadi. */
  explain?: boolean;
  className?: string;
}

/** "Zona A · 01 stellaj · 2-qator · 3-o'rin" — kodning inson tilidagi tarjimasi. */
export const cellCodeMeaning = (code: string): string | null => {
  const parts = parseCellCode(code);
  if (parts === null) return null;
  return [
    t('warehouse.codeZone', { zone: parts.zoneCode }),
    t('warehouse.codeRack', { rack: parts.rackCode }),
    t('warehouse.codeLevel', { level: parts.level }),
    t('warehouse.codeIdx', { idx: parts.idx }),
  ].join(' · ');
};

export const CellCode = ({ code, explain = false, className }: CellCodeProps) => {
  const meaning = cellCodeMeaning(code);

  return (
    <span className={cn('flex min-w-0 flex-col gap-0.5', className)}>
      <span
        className="tabular min-w-0 truncate"
        // Tushuntirish ko'rinib turmagan joyda ham sichqoncha ostida chiqadi.
        title={explain || meaning === null ? undefined : meaning}
      >
        {code}
      </span>
      {/*
        Ma'no BIR MARTA chiqadi. `explain` bo'lsa ko'rinadigan matn ekran
        o'quvchiga ham yetadi; ikkinchi `sr-only` nusxa uni ikki marta
        o'qib berardi.
      */}
      {meaning === null ? null : (
        <span className={explain ? 'text-text-faint text-xs' : 'sr-only'}>{meaning}</span>
      )}
    </span>
  );
};
